import apiClient from '..'

export const getClientsWithEmployeesAPI = (filters = {}) => {
  return apiClient.get('client-Employees/clients-with-employees', { params: filters })
}
export const getClientWithEmployeesByIdAPI = (id, filters = {}) => {
  return apiClient.get(`client-Employees/clients/${id}`, {
    params: filters,
  })
}
